import script from "./PatientImage.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientImage.vue?vue&type=script&setup=true&lang=js"

import "./PatientImage.vue?vue&type=style&index=0&id=ebf20f82&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ebf20f82"]])

export default __exports__